<div class="confirm-dialog">
  <div class="confirm-msg">
    {{ message }}
  </div>
  <div class="dialog-actions">
    <button class="primary_button" (click)="onConfirm()">Confirm</button>
    <button class="secondary_button" (click)="onCancel()">Cancel</button>
  </div>
</div>
